<template>
  <li class="rtree-node">
    <div
      class="rtree-card"
      :class="{ 'rtree-card--root': isRoot }"
    >
      <div class="rtree-name">
        {{ node.customerName }}
      </div>
      <div
        v-if="node.memberNumber"
        class="text-caption grey--text"
      >
        No.{{ node.memberNumber }}
      </div>
      <div
        v-if="!isRoot"
        class="text-caption primary--text"
      >
        {{ formatCurrency(node.confirmedSales || 0) }}
      </div>
    </div>

    <ul
      v-if="hasChildren"
      class="rtree-children"
    >
      <CustomerReferralTreeNode
        v-for="child in node.children"
        :key="child.customerId"
        :node="child"
      />
    </ul>
  </li>
</template>

<script>
import { computed } from '@vue/composition-api'
import { formatCurrency } from '@/utils/formatters'

export default {
  // 再帰コンポーネント（name参照で自身を子として描画する）
  name: 'CustomerReferralTreeNode',
  props: {
    node: {
      type: Object,
      required: true,
    },
    // ルートノードは金額を表示しない（紹介売上合計に含まれないため）
    isRoot: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const hasChildren = computed(() => (props.node.children || []).length > 0)

    return {
      hasChildren,
      formatCurrency,
    }
  },
}
</script>
